import { useState, useEffect } from "react";
import Select from "react-select";
import { motion } from "framer-motion";
import { ArrowRight, Plus, Filter, RotateCcw } from "lucide-react";
import Campo from "../posgrados/Campo";
import Modalidad from "../posgrados/Modalidad";
import DataFetcherEscuelaNegocios from "../../hooks/DataFetcherEscuelaNegocios";

function OfferEscuelaNegocios() {
  const optionsModalidad = [
    { value: "todos", label: "Todas las modalidades" },
    { value: "En línea", label: "En línea" },
    { value: "Presencial", label: "Presencial" },
  ];

  const getInitialValue = (param, options) => {
    const params = new URLSearchParams(window.location.search);
    let value = params.get(param);
    return options.find((o) => o.value === value) || options[0];
  };

  const [modalidadSeleccionada, setModalidadSeleccionada] = useState(
    getInitialValue("modalidad", optionsModalidad),
  );

  useEffect(() => {
    const params = new URLSearchParams();

    if (modalidadSeleccionada.value !== "todos") {
      params.set("modalidad", modalidadSeleccionada.value);
    }

    const newUrl =
      window.location.pathname +
      (params.toString() ? `?${params.toString()}` : "");

    window.history.replaceState({}, "", newUrl);
  }, [modalidadSeleccionada]);

  const limpiarFiltros = () => {
    setModalidadSeleccionada(optionsModalidad[0]);
  };

  const DataDisplayOfertaPosgrados = ({ data }) => {
    const cleanText = (text) => {
      if (!text) return "";
      return text
        .toLowerCase()
        .trim()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    };

    const badgeColors = {
      Maestría: "bg-blue-100 text-blue-800 border border-blue-200",
      Especialización: "bg-purple-100 text-purple-800 border border-purple-200",
      Doctorado: "bg-emerald-100 text-emerald-800 border border-emerald-200",
    };

    // 1. FILTRAR los datos (Únicamente por Modalidad)
    const filtered = data.filter((item) => {
      if (modalidadSeleccionada.value !== "todos") {
        if (!item.field_modalidad) return false;

        const seleccionLimpia = cleanText(modalidadSeleccionada.value);
        let modalidadesDelItem = [];

        if (Array.isArray(item.field_modalidad)) {
          modalidadesDelItem = item.field_modalidad.map((m) =>
            cleanText(m).replace("_", " "),
          );
        } else if (typeof item.field_modalidad === "string") {
          modalidadesDelItem = [
            cleanText(item.field_modalidad).replace("_", " "),
          ];
        }

        const coincideDirecto = modalidadesDelItem.includes(seleccionLimpia);
        const coincideTextoCruzado = modalidadesDelItem.some(
          (m) => m.includes(seleccionLimpia) || seleccionLimpia.includes(m),
        );

        if (!coincideDirecto && !coincideTextoCruzado) {
          return false;
        }
      }

      return true;
    });

    // 2. ORDENAR los datos
    const filteredData = [...filtered].sort((a, b) => {
      const dateA = a.field_inicio_clases || "";
      const dateB = b.field_inicio_clases || "";

      const dateComparison = dateB.localeCompare(dateA, "es");
      if (dateComparison !== 0) {
        return dateComparison;
      }

      const titleA = cleanText(a.title);
      const titleB = cleanText(b.title);
      return titleA.localeCompare(titleB, "es");
    });

    return (
      <div className="px-16 md:px-10">
        {/* Contenedor de Filtros Simplificado */}
        <div className="wrapper-filtros layout9">
          <div>
            <p>
              <b>Modalidad</b>
            </p>
            <Select
              options={optionsModalidad}
              value={modalidadSeleccionada}
              onChange={setModalidadSeleccionada}
            />
          </div>

          <div>
            <button
              className="btn-reset-filtros flex items-center gap-2"
              onClick={limpiarFiltros}
            >
              <RotateCcw size={16} />
              Limpiar filtros
            </button>
          </div>
        </div>

        {/* Contador */}
        <div className="mb-6 flex items-center justify-between">
          <p className="text-gray-700 flex items-center gap-2">
            <Filter size={16} />
            <span className="font-bold">{filteredData.length}</span> programas
            encontrados
          </p>
        </div>

        {/* Grid de Tarjetas */}
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {filteredData.map((item) => (
            <motion.a
              key={item.id}
              href={item.field_url}
              rel="noreferrer"
              className="group relative block bg-white rounded-2xl shadow-md overflow-hidden"
              initial="rest"
              animate="rest"
              whileHover="hover"
            >
              <div className="h-40 overflow-hidden">
                <img
                  src={item.field_imagen_portada}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                />
              </div>

              <motion.div
                variants={{
                  rest: { scale: 1, opacity: 0.8 },
                  hover: { scale: 1.2, opacity: 1 },
                }}
                className="absolute top-4 right-4 bg-white/90 backdrop-blur-md rounded-full p-2 shadow-md"
              >
                <Plus size={12} />
              </motion.div>

              <div className="p-5 space-y-3">
                <div className="flex gap-2 flex-wrap">
                  <span
                    className={`text-xs font-semibold px-2.5 py-1 rounded-md ${badgeColors[item.field_programa] || "bg-gray-100 text-gray-800"}`}
                  >
                    {item.field_programa}
                  </span>
                </div>

                <h3 className="text-base font-bold leading-tight p-0">
                  {item.title}
                </h3>

                {item.field_modalidad && (
                  <div
                    className="
                    [&_p]:text-sm 
                   [&_p]:text-gray-600 

                   [&_p]:p-0
                    [&_p]:inline-flex
                    [&_p]:leading-none
                         [&_ul]:p-0
                            [&_ul]:m-0
                    [&_li]:text-sm 
                   [&_li]:text-gray-600 
                   [&_li]:py-0      
                   [&_li]:pt-1           
                    [&_li]:leading-none "
                  >
                    <p>
                      <strong>Modalidad: </strong> 
                    </p>
                    <Modalidad value={item.field_modalidad} />
                  </div>
                )}

                {item.field_duracion && (
                  <p className="text-sm text-gray-600 p-0 leading-none">
                    <strong>Duración:</strong>{" "}
                    {item.field_duracion
                      .replaceAll("_", " ")
                      .replace("anos", "años")
                      .replace("ano", "año")}
                  </p>
                )}

                {item.field_facultad && (
                  <p className="text-sm text-gray-600 p-0 leading-none">
                    <strong>Facultad:</strong> {item.field_facultad}
                  </p>
                )}

                {item.field_campo_amplio && (
                  <p className="text-sm text-gray-600 p-0 leading-none">
                    <strong>Campo: </strong>
                    <Campo value={item.field_campo_amplio} />
                  </p>
                )}

                {item.field_inicio_clases && (
                  <p className="text-sm text-gray-600 p-0 leading-none">
                    <strong>Inicio de clases:</strong>{" "}
                    {item.field_inicio_clases}
                  </p>
                )}
              </div>

              <motion.div
                variants={{
                  rest: { opacity: 0 },
                  hover: { opacity: 1 },
                }}
                className="absolute inset-0 bg-black/10 flex items-center justify-center"
              >
                <ArrowRight size={44} className="text-white" />
              </motion.div>
            </motion.a>
          ))}
        </div>
      </div>
    );
  };

  return (
    <DataFetcherEscuelaNegocios>
      {(data) => <DataDisplayOfertaPosgrados data={data} />}
    </DataFetcherEscuelaNegocios>
  );
}

export default OfferEscuelaNegocios;
